import GiftItem from 'components/Molecules/LoyaltyStore/GiftItem';
import React from 'react';

const ListGiftCategory = ({ listGift }) => {
  return (
    <>
      {listGift.map((gift, index) => (
        <div className='p-0 lg:pr-4 lg:pb-6' key={index}>
          <GiftItem giftData={gift} horizontal />
        </div>
      ))}
    </>
  );
};

export default ListGiftCategory;
